import { Button, ButtonProps } from "antd";
import classNames from "classnames";
import styles from "./style.module.scss";
import { forwardRef } from "react";
import VLPopover from "../../VLPopover";

interface VLButtonPropsBase extends ButtonProps {
  text: string;
  icon?: React.ReactNode;
  tooltip?: string;
  danger?: boolean;
}

export interface VLPrimaryButtonProps extends VLButtonPropsBase {
  type: "primary";
  isGradient?: boolean;
}

interface VLNormalButtonProps extends VLButtonPropsBase {
  type: "text" | "default";
}

export type VLButtonProps = VLNormalButtonProps | VLPrimaryButtonProps;

const VLButton = forwardRef<HTMLButtonElement, VLButtonProps>(
  (
    { type, text, icon, disabled, loading, onClick, tooltip, danger, ...rest },
    ref
  ) => {
    const btnClassnames = classNames(styles.vlButton, {
      [styles.primary]:
        type === "primary" && !(rest as VLPrimaryButtonProps).isGradient,
      [styles.text]: type === "text",
      [styles.default]: type === "default",
      [styles.gradient]:
        type === "primary" && (rest as VLPrimaryButtonProps).isGradient,
      [styles.danger]: danger,
    });

    return (
      <VLPopover content={tooltip ?? undefined}>
        <Button
          ref={ref}
          className={btnClassnames}
          type={type}
          disabled={disabled}
          onClick={disabled ? undefined : onClick}
          loading={loading}
          danger={danger}
          {...rest}
        >
          <div className={styles.content}>
            {icon && !loading && <div>{icon}</div>}
            <div className={styles.textContent}>{text}</div>
          </div>
        </Button>
      </VLPopover>
    );
  }
);

export default VLButton;
